export default __webpack_public_path__ + "static/media/ea1.8cc2140e.jpeg";